module.exports = {
  "country": "DK",
  "artist": "Ben & Tan",
  "song": "Yes",
  "year": "2020",
  "place": "CCL",
  "spotify": "1nAvS4GbkxR7iISU5ZfLPf"
};